<template>
    <ExamEndView :total="examTotal" :num="oNum" :pa="pa"></ExamEndView>
</template>
<script>
import examDelegate from '@/delegate/examDelegate'
import ExamEndView from './ExamEndView'
export default {
    name: 'ExamEnd',
    mixins: [examDelegate],
    computed: {
        pa() {
            return ((this.oNum / this.examTotal * 100) << 1) >> 1
        }
    },
    components: {
        ExamEndView
    }
}
</script>
<style lang="less" scoped>
@import 'val.less';
.til {
    height: 60px;
    margin: 40px 0px 28px 0px;
    display: inline-block;
    > div {
        float: left;
    }
    .gup {
        padding: 0px 17px;
        text-align: left;
        .w1 {
            line-height: 42px;
            font-size: 30px;
            color: @main-color;
            font-weight: bold;
        }
        .w2 {
            line-height: 28px;
            font-size: 20px;
        }
    }
}
.mm {
    width: 100%;
    height: 154px;
    display: flex;
    justify-content: center;
    > div {
        width: 130px;
        height: 154px;
        padding: 56px 0px 0px 0px;
        margin: 0px;
        box-sizing: border-box;
        font-size: 30px;
        color: #fff;
    }
    .m1 {
        background: url('../assets/img/test-answer.png');
        margin-right: 20px;
    }
    .m2 {
        background: url('../assets/img/test-answer-good.png');
    }
}
</style>



// WEBPACK FOOTER //
// src/components/ExamEnd.vue